<template>
  <div>
    <!-- 问题登记 -->
    <el-dialog :title="$t('message.issueCreate')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="680px" center>
      <div class="content">
        <el-form :model="form" :rules="rules" ref="form" label-width="130px">
          <!-- 客户ID -->
          <el-form-item label="客户ID:" prop="client_id">
            <div class="row">
              <div class="input">
                <el-input v-model="form.client_id" placeholder="请输入客户ID" @blur="getClientInfo" />
              </div>
              {{ form.realname }}
            </div>

          </el-form-item>
          <!-- *问题图片： -->
          <el-form-item label="问题图片:" prop="problem_images">
            <div class="image">
              <div v-for="(item, index) in form.problem_images" :key="index" class="image-item">
                <img :src="item" class="avatar" />
                <i class="el-icon-error" @click="removeImage(index)"></i>

              </div>
              <el-upload class="avatar-uploader" action="/api/upload" :show-file-list="false" list-type="picture-card"
                :before-upload="beforeAvatarUpload" :http-request="httpup" multiple>
                <i class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </div>
          </el-form-item>
          <!-- *售后问题说明 -->
          <el-form-item label="售后问题说明:" prop="problem_desc">
            <el-input v-model="form.problem_desc" placeholder="请输入售后问题说明" type="textarea" />
          </el-form-item>
          <!-- 问题分类-->
          <el-form-item label="问题分类:">
            <el-select v-model="form.problem_category" placeholder="请选择问题分类">
              <el-option v-for="(item, index) in problemCategoy" :label="item.value" :value="item.value" :key="index" />
            </el-select>
          </el-form-item>
          <!-- 选择商品： -->
          <el-form-item label="选择商品:">
            <el-radio-group v-model="radio" @change="setRadio">
              <el-radio :label="1">配送单</el-radio>
              <el-radio :label="2">订单</el-radio>
            </el-radio-group>
            <div class="row">
              <div class="input" v-if="radio == 1">
                <el-input v-model="form.porder_sn" placeholder="请输入配送单" />
              </div>
              <div class="input" v-else>
                <el-input v-model="form.order_sn" placeholder="请输入订单" />
              </div>
              <el-button type="primary" @click="getPorderDetail">选择商品</el-button>
            </div>
            <!-- 配送单详情 -->
            <div class="list" v-if="radio == 1">
              <p v-for="(item, index) in form.porder_detail" :key="index">
                {{ item.order_sn }} No{{ item.sorting }}
              </p>
            </div>
            <!-- 订单详情 -->
            <div class="list" v-if="radio == 2">
              <p v-for="(item, index) in form.order_detail" :key="index">
                {{ item.order_sn }} No{{ item.sorting }}
              </p>
            </div>
          </el-form-item>
          <!-- *不良数： -->
          <el-form-item label="不良数:" prop="problem_num">
            <el-input v-model="form.problem_num" placeholder="请输入不良数" type="number" />
          </el-form-item>
          <!-- *不良金额（元）： -->
          <el-form-item label="不良金额（元）:" prop="problem_amount">
            <el-input v-model="form.problem_amount" placeholder="请输入不良金额（元）" type="number" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">
          {{ $t("message.cancel") }}
        </el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="save">
          {{ $t("message.ok") }}
        </el-button>
      </span>
    </el-dialog>
    <!-- 配送单详情 -->
    <porderDetail ref="porderDetail" />
    <!-- 订单详情 -->
    <orderDetail ref="orderDetail" />
  </div>
</template>
<script>
import porderDetail from './porderDetail.vue'
import orderDetail from './orderDetail.vue'

export default {
  components: {
    porderDetail,
    orderDetail
  },
  data() {
    return {
      form: {
        client_id: '',
        problem_images: [],
        problem_desc: '',
        problem_category: '',
        product_id: '',
        order_id: '',
        problem_num: '',
        problem_amount: '',
        porder_sn: '',
        order_sn: '',
        porder_detail: [],
        order_detail: []
      },
      rules: {
        client_id: [{ required: true, message: '请输入客户ID', trigger: 'blur' }],
        problem_images: [{ required: true, message: '请上传问题图片', trigger: 'blur' }],
        problem_desc: [{ required: true, message: '请输入售后问题说明', trigger: 'blur' }],
        problem_category: [{ required: true, message: '请选择问题分类', trigger: 'blur' }],
        product_id: [{ required: true, message: '请输入配送单', trigger: 'blur' }],
        order_id: [{ required: true, message: '请输入订单', trigger: 'blur' }],
        problem_num: [{ required: true, message: '请输入不良数', trigger: 'blur' }],
        problem_amount: [{ required: true, message: '请输入不良金额（元）', trigger: 'blur' }],
      },
      dialogVisible: false,
      problemCategoy: [],
      radio: 1
    };
  },
  created() {
    this.aftersaleIssueProblemCategoryEnum()


  },
  methods: {
    // 售后问题分类枚举
    aftersaleIssueProblemCategoryEnum() {
      this.$api.siteConfiguration.aftersaleIssueProblemCategoryEnum().then(res => {
        this.problemCategoy = res.data
      })
    },
    // 保存
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$api.siteConfiguration.aftersaleIssueCreate(this.form).then(res => {
            this.$message.success(res.msg);
            if (this.$route.name == 'issueRegistrationList') {
              this.$parent.aftersaleIssueList();
              this.$parent.aftersaleIssueStatusStatistics();
            }
            this.dialogVisible = false;
          })
        } else {
          this.$message.error('请填写完整信息');
        }
      })
    },
    // 选择商品类型改变时
    setRadio() {
      this.form.porder_detail = []
      this.form.order_detail = []
      this.form.porder_sn = ''
      this.form.order_sn = ''
    },
    // 删除沟通截图
    removeImage(index) {
      this.form.problem_images.splice(index, 1);
    },
    // 上传沟通截图前
    beforeAvatarUpload(file) {
      if (this.form.problem_images.length >= 8) {
        this.$message.error('最多上传 8 张问题图片!');
        return false;
      }
      const isJPG = file.type === 'image/jpeg';
      const isPNG = file.type === 'image/png';
      const isSVG = file.type === 'image/svg+xml';
      if (!isJPG && !isPNG && !isSVG) {
        this.$message.error('上传沟通截图只能是 JPG/PNG/SVG 格式!');
      }
      return isJPG || isPNG || isSVG;
    },
    // 上传沟通截图
    // 图片上传事件
    async httpup(file) {
      let data = await this.createClient(file)
      this.form.problem_images.push(data.data)
    },
    // 获取客户信息
    getClientInfo() {
      let datas = {
        id: this.form.client_id
      }
      this.form.realname = ''
      this.$api.clienteleApi.clientList(datas).then((res) => {
        if (res.data.data.length == 0) {
          this.$message.error('客户ID不存在');
          return;
        }
        this.form.realname = res.data.data[0].realname;
        this.$forceUpdate()
      });
    },
    // 获取配送单详情
    getPorderDetail() {
      if (this.radio == 1) {
        if (!this.form.porder_sn) {
          this.$message.error('请输入配送单');
          return;
        }
        this.$refs.porderDetail.porder_sn = this.form.porder_sn
        this.$refs.porderDetail.getPorderDetail()
      } else if (this.radio == 2) {
        if (!this.form.order_sn) {
          this.$message.error('请输入订单');
          return;
        }
        this.$refs.orderDetail.order_sn = this.form.order_sn
        this.$refs.orderDetail.getOrderDetail()
      }

    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;

  .row {
    display: flex;

    .input {
      width: 300px;
      margin-right: 20px;
    }
  }

  .image {
    display: flex;
    flex-wrap: wrap;

    .image-item {
      position: relative;
      margin-bottom: 10px;
      margin-right: 10px;

      .el-icon-error {
        position: absolute;
        top: -5px;
        right: -5px;
        font-size: 20px;
        color: #ff4949;
        cursor: pointer;
      }
    }

    .avatar {
      width: 80px;
      height: 80px;
      border-radius: 4px;

    }
  }

  .avatar-uploader {
    height: 80px;
    width: 80px;
  }

  /deep/.el-upload--picture-card {
    width: 80px;
    height: 80px;
    line-height: 80px;
  }

  /deep/.el-textarea__inner {
    height: 100px;
  }

  .list {
    margin-top: 10px;

    p {
      line-height: 30px;
    }
  }
}
</style>